export const DEFAULT_LOCALE = "en-CH";
export const AvailableLocales = ["en-CH", "de", "fr", "it"] as const;
export const AvailableLocalesIntl = [
  "shared.locale.en-CH",
  "shared.locale.de",
  "shared.locale.fr",
  "shared.locale.it",
] as const;

export type TAvailableLocalesIntl = {
  id: (typeof AvailableLocales)[number];
  intlMessage: (typeof AvailableLocalesIntl)[number];
};

export const AvailableLocalesWithIntl: TAvailableLocalesIntl[] = AvailableLocales.map(l => ({
  id: l,
  intlMessage: `shared.locale.${l}`,
}));

export const LocaleMapping: Record<string, AppLocale> = {
  "en-US": "en-CH",
  en: "en-CH",
  de: "de",
  fr: "fr",
  it: "it",
};

export type AppLocale = (typeof AvailableLocales)[number];

export * from "./constants";
export * from "./types";
export * from "./mapToCopyFileCare";
export * from "./mapToCopyFilePortal";
export * from "./mapToCopyFileShared";
